import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
type CTABandProps = {
  title: string;
  text: string;
  primaryLabel?: string;
  primaryTo?: string;
  secondaryLabel?: string;
  secondaryTo?: string;
};
export function CTABand({
  title,
  text,
  primaryLabel = 'Start a conversation',
  primaryTo = '/contact',
  secondaryLabel,
  secondaryTo
}: CTABandProps) {
  return <section className="border-t border-ink-100 bg-bronze-50" data-id="element-19" data-mp="3v087qnn6tbwo">
      <div className="mx-auto flex max-w-container flex-col gap-8 px-6 py-16 lg:flex-row lg:items-center lg:justify-between lg:px-10 lg:py-20" data-id="element-20" data-mp="2xh19u540u54">
        <div className="max-w-2xl" data-id="element-21" data-mp="7piat8aw86rg">
          <h2 className="text-2xl font-semibold leading-tight tracking-tight text-ink-900 sm:text-3xl" data-id="element-22" data-mp="7qa58fsr7yg5">
            {title}
          </h2>
          <p className="mt-3 text-base leading-relaxed text-ink-600" data-id="element-23" data-mp="hmwox19cgjgl">{text}</p>
        </div>
        <div className="flex shrink-0 flex-wrap items-center gap-3" data-id="element-24" data-mp="mky95piiaotn">
          <Link to={primaryTo} className="group inline-flex items-center gap-2 whitespace-nowrap bg-ink-900 px-6 py-3.5 text-sm font-medium text-white transition-colors duration-150 ease-out hover:bg-bronze-600" data-id="element-25" data-mp="mj3n27vi0qnz">
            {primaryLabel}
            <ArrowRightIcon className="h-4 w-4 transition-transform duration-200 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-26" data-mp="1ei0w62h3rkfo" />
          </Link>
          {secondaryLabel && secondaryTo && <Link to={secondaryTo} className="inline-flex items-center whitespace-nowrap border border-ink-300 px-6 py-3.5 text-sm font-medium text-ink-800 transition-colors duration-150 ease-out hover:border-ink-900" data-id="element-27" data-mp="227lgopswmpr2">
              {secondaryLabel}
            </Link>}
        </div>
      </div>
    </section>;
}